import { useDispatch, useSelector } from "react-redux";

import useInvalidateOpportunityQueries from "app/pages/sales-intelligence/pages/opportunity-list/hooks/useInvalidateOpportunityQueries";
import ExcludeDuplicateOpportunitiesModal from "app/pages/sales-intelligence/sub-modules/opportunities/components/modals/ExcludeDuplicateOpportunitiesModal/ExcludeDuplicateOpportunitiesModal";
import useCurrentStaticList from "app/pages/sales-intelligence/sub-modules/opportunities/hooks/useCurrentStaticList";
import { toggleExcludeListsDuplicatesModal } from "app/pages/sales-intelligence/sub-modules/opportunities/store/action-creators";
import { selectIsExcludeDuplicateOpportunitiesModalOpen } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import { is } from "app/pages/sales-intelligence/utils/type-guards";

import { useModifiedExcludeFilters } from "./hooks";

export const ExcludeDuplicateOpportunitiesModalContainer = () => {
    const dispatch = useDispatch();
    const currentList = useCurrentStaticList();
    const isModalOpen = useSelector(selectIsExcludeDuplicateOpportunitiesModalOpen);

    const { handleFiltersUpdate, isReady } = useModifiedExcludeFilters(dispatch);
    const invalidateOpportunitiesQueries = useInvalidateOpportunityQueries();
    const handleModalClose = (): void => {
        dispatch(toggleExcludeListsDuplicatesModal(false));
        if (!is.undefined(currentList)) {
            invalidateOpportunitiesQueries(currentList.opportunityListId);
        }
    };

    return (
        isModalOpen &&
        isReady && (
            <ExcludeDuplicateOpportunitiesModal
                isOpen={isModalOpen}
                onClose={handleModalClose}
                onExclude={handleFiltersUpdate}
            />
        )
    );
};
